import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { get, post } from "../../utils/apiManager";
import { baseURL } from "../../config/config";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import SuccessModal from "../../components/SuccessModal";
import Select from "react-select";

const Index = () => {
  const { register, handleSubmit, getValues, setValue } = useForm();
  const { register: registerManageField, control, handleSubmit: handleSubmitManageField, formState: { errors: ErrorsManageField }, reset, watch, setValue: setValueManageField } = useForm();

  const location = useLocation();
  const Navigate = useNavigate();
  let id = location?.search?.split("?")[1];

  const [manageField, setManageField] = useState([]);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [count, setCount] = useState();
  const [checkedValue, setCheckedValue] = useState(false);
  const [manageFieldData, setManageFieldData] = useState("");
  const [choicesArr, setChoicesArr] = useState([]);
  const [category, setCategory] = useState([]);
  const [pageData, setPageData] = useState({ page: 1, perPage: 5000 });
  const [modalData, setModalData] = useState({ message: "", show: false });

  useEffect(() => { getAllCategory(); }, []);

  const getAllCategory = () => {
    get(`/category?page=1&perPage=1000&searchItem=${getValues("companyName") || ""}`)
      .then((res) => setCategory(res?.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => { getAllManageField(); }, [pageData]);

  useEffect(() => {
    if (manageFieldData !== "") {
      setValueManageField("fieldLabel", manageFieldData?.fieldLabel);
      setValueManageField("fieldType", manageFieldData?.fieldType);
      setValueManageField("width", manageFieldData?.width);
      setValueManageField("Choices", manageFieldData?.choices);
      setValueManageField("defaultValue", manageFieldData?.defaultValue);
      setValueManageField("currency", manageFieldData?.currency);
      setValueManageField("currenacyPosition", manageFieldData?.currenacyPosition);
      setValueManageField("defaultCheckedValue", manageFieldData?.defaultCheckedValue);
      setValueManageField("align", manageFieldData?.align);
      setValueManageField("defaultValueQuan", manageFieldData?.defaultValueQuan);
    }
  }, [manageFieldData]);

  const getAllManageField = () => {
    get(`/default-manage-field/all/${id}?page=${pageData?.page || 1}&perPage=${pageData?.perPage || 10}&searchItem=${getValues("companyName") || ""}`)
      .then((res) => {
        setManageField(res?.data);
        const mainCat = res?.data?.find((d) => d.fieldLabel.toLowerCase().includes("main category"));
        if (mainCat) setChoicesArr(mainCat.choices.split("\n").map((d) => d));
        setCount(res?.pages);
      }).catch((err) => console.log(err));
  };

  const onSubmit = () => getAllManageField();
  const clearSearch = () => { setValue("companyName", ""); getAllManageField(); };

  const onSubmitManageField = (data) => {
    if (data.Choices && data.Choices.length > 0) data.choices = data.Choices.join(`\n`);
    let Url;
    if (manageFieldData !== "") { Url = `${baseURL}/default-manage-field/update`; data.id = manageFieldData?._id; }
    else { Url = `${baseURL}/default-manage-field/add`; data.templateId = id; }
    post(Url, data)
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); reset(); setShowModel(false); getAllManageField(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const changeStatus = (fieldId, status) => {
    post(`${baseURL}/default-manage-field/status`, { id: fieldId, status: !status })
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllManageField(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const deleteHandler = (fieldId) => {
    Swal.fire({ title: 'Are you sure?', text: 'This will delete the manage field.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', cancelButtonColor: '#6b7a99', confirmButtonText: 'Yes, delete it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/default-manage-field/delete`, { id: fieldId })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllManageField(); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const checkBoxHandler = (email) => {
    setCheckBoxData(prev => prev.includes(email) ? prev.filter(i => i !== email) : [...prev, email]);
  };

  const allCheck = (val) => {
    setCheckBoxData(val ? manageField.map(item => item.email) : []);
    setCheckedValue(!checkedValue);
  };

  useEffect(() => {
    if (manageField?.length > 0) setCheckedValue(manageField.length === checkBoxData.length);
  }, [checkBoxData]);

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    const reorderedItems = Array.from(manageField);
    const [movedItem] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, movedItem);
    setManageField(reorderedItems);
    post(`/default-manage-field/update-sequence`, { items: reorderedItems })
      .then((res) => { if (res?.status) getAllManageField(); else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const pill = (active) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
      <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
    </span>
  );

  const thS = { padding: '10px 14px', fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#9aa5c0', textAlign: 'left', borderBottom: '1px solid #edf0f7', background: '#f8f9fc', whiteSpace: 'nowrap' };
  const tdS = { padding: '11px 14px', fontSize: 14, color: '#3a4a6a', borderBottom: '1px solid #f0f2f8', verticalAlign: 'middle' };
  const inputS = (err) => ({ width: '100%', padding: '10px 14px', borderRadius: 8, border: `1.5px solid ${err ? '#AD2429' : '#e2e8f0'}`, fontSize: 14, color: '#0a1628', background: '#fff', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' });

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #edf0f7' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Manage Fields</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Drag rows to reorder · Click a field to edit</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => Navigate('/admin/default-template')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
            <button onClick={() => { setShowModel(true); setValueManageField("width", 100); setValueManageField("align", "left"); setManageFieldData(""); reset(); }}
              style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              + Add Field
            </button>
          </div>
        </div>

        {/* Search */}
        <div style={{ padding: '12px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <input placeholder="Search fields..." {...register("companyName")} style={{ ...inputS(false), width: 220 }} />
          <button onClick={() => getAllManageField()} style={{ background: '#1a2744', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Search</button>
          <button onClick={clearSearch} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Clear</button>
        </div>

        {/* Drag hint */}
        <div style={{ padding: '8px 24px', background: '#fffbeb', borderBottom: '1px solid #fef3c7', fontSize: 12, color: '#92400e', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>⇅</span> Drag rows to reorder fields
        </div>

        {/* Table with DnD */}
        <div style={{ overflowX: 'auto' }}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-table">
              {(provided) => (
                <table style={{ width: '100%', borderCollapse: 'collapse' }} ref={provided.innerRef} {...provided.droppableProps}>
                  <thead>
                    <tr>
                      {['⇅', 'Field Label', 'Field Type', 'Width', 'Align', 'Create Date', 'Status', 'Actions'].map(h => <th key={h} style={thS}>{h}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {manageField?.length > 0 ? manageField.map((item, index) => (
                      <Draggable key={item._id} draggableId={item._id} index={index}>
                        {(provided) => (
                          <tr ref={provided.innerRef} {...provided.draggableProps}
                            onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                            <td style={{ ...tdS, width: 40, cursor: 'grab' }} {...provided.dragHandleProps}>
                              <span style={{ color: '#c0c8d8', fontSize: 16 }}>⠿</span>
                            </td>
                            <td style={{ ...tdS, fontWeight: 600, color: '#0a1628' }}>{item?.fieldLabel}</td>
                            <td style={tdS}><span style={{ background: '#f0f4f8', color: '#5a6a8a', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>{item?.fieldType}</span></td>
                            <td style={tdS}>{item?.width}</td>
                            <td style={tdS}>{item?.align}</td>
                            <td style={{ ...tdS, fontSize: 13, color: '#6b7a99' }}>{moment(item?.createdAt).format("MMM DD, YYYY hh:mm A")}</td>
                            <td style={tdS}>{pill(item?.isActive)}</td>
                            <td style={tdS}>
                              <div style={{ display: 'flex', gap: 5 }}>
                                <button onClick={() => changeStatus(item._id, item?.isActive)} title={item?.isActive ? 'Deactivate' : 'Activate'}
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: item?.isActive ? '#fee2e2' : '#dcfce7', color: item?.isActive ? '#b91c1c' : '#15803d', cursor: 'pointer', fontSize: 12 }}>
                                  {item?.isActive ? '✕' : '✓'}
                                </button>
                                <button onClick={() => { setShowModel(true); setManageFieldData(item); }} title="Edit"
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: 12 }}>✎</button>
                                <button onClick={() => deleteHandler(item._id)} title="Delete"
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', fontSize: 12 }}>🗑</button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    )) : (
                      <tr><td colSpan={8} style={{ ...tdS, textAlign: 'center', padding: '48px', color: '#9aa5c0' }}>No fields found</td></tr>
                    )}
                    {provided.placeholder}
                  </tbody>
                </table>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>

      {/* Add/Edit Manage Field Modal */}
      {showModel && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <div style={{ padding: '18px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#0a1628' }}>
                {manageFieldData !== "" ? 'Edit Field' : 'Add Field'}
              </h3>
              <button onClick={() => { setShowModel(false); setManageFieldData(""); }} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#9aa5c0' }}>×</button>
            </div>
            <form onSubmit={handleSubmitManageField(onSubmitManageField)} style={{ padding: '24px' }}>

              {/* Field Label */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Field Label</label>
                <input placeholder="Enter field label" type="text" style={inputS(ErrorsManageField.fieldLabel)} {...registerManageField("fieldLabel", { required: true })} />
                {ErrorsManageField.fieldLabel && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
              </div>

              {/* Field Type + Width */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'flex', gap: 4 }}>Field Type <span style={{ color: '#AD2429' }}>*</span></label>
                  <select style={{ ...inputS(ErrorsManageField.fieldType), appearance: 'none' }} {...registerManageField("fieldType", { required: true })}>
                    <option value="text">Text</option>
                    <option value="textarea">Textarea</option>
                    <option value="select">Select</option>
                    <option value="money">Money</option>
                    <option value="file">File</option>
                    <option value="checkbox">Checkbox</option>
                  </select>
                  {ErrorsManageField.fieldType && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
                </div>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Width</label>
                  <input placeholder="e.g. 100" type="text" style={inputS(ErrorsManageField.width)} {...registerManageField("width", { required: true })} />
                  {ErrorsManageField.width && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
                </div>
              </div>

              {/* Quantity default value */}
              {(watch("fieldLabel")?.toLowerCase() === "quantity" || getValues("fieldLabel")?.toLowerCase() === "quantity") && (
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Default Value</label>
                  <input placeholder="Default quantity value" type="text" style={inputS(false)} defaultValue="1" {...registerManageField("defaultValueQuan")} />
                </div>
              )}

              {/* Select type: Choices + Default Value */}
              {watch("fieldType") === "select" && (
                <>
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Choices</label>
                    <Controller
                      control={control}
                      name="Choices"
                      render={({ field: { onChange, value, ref } }) => (
                        <Select
                          inputRef={ref}
                          value={category.map(d => ({ label: d.name, value: d.name })).filter(c => value?.includes(c.value))}
                          onChange={(val) => onChange(val.map(c => c.value))}
                          options={category.map(d => ({ label: d.name, value: d.name }))}
                          isMulti
                        />
                      )}
                    />
                    {ErrorsManageField.choices && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Default Value</label>
                    <input placeholder="Enter default value" type="text" style={inputS(ErrorsManageField.defaultValue)} {...registerManageField("defaultValue", { required: watch("fieldType") === "select" })} />
                    {ErrorsManageField.defaultValue && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
                  </div>
                </>
              )}

              {/* Money type: Currency */}
              {watch("fieldType") === "money" && (
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Currency</label>
                  <select style={{ ...inputS(ErrorsManageField.currency), appearance: 'none' }} {...registerManageField("currency", { required: watch("fieldType") === "money" })}>
                    <option value="$">$ (USD)</option>
                  </select>
                  {ErrorsManageField.currency && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
                </div>
              )}

              {/* Checkbox type: Default checked */}
              {watch("fieldType") === "checkbox" && (
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Default Checked</label>
                  <select style={{ ...inputS(ErrorsManageField.defaultCheckedValue), appearance: 'none' }} {...registerManageField("defaultCheckedValue", { required: watch("fieldType") === "checkbox" })}>
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                  </select>
                  {ErrorsManageField.defaultCheckedValue && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
                </div>
              )}

              {/* Align */}
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Align</label>
                <input placeholder="e.g. left" type="text" style={inputS(ErrorsManageField.align)} {...registerManageField("align", { required: true })} />
                {ErrorsManageField.align && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
              </div>

              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: '1px solid #edf0f7' }}>
                <button type="button" onClick={() => { setShowModel(false); setManageFieldData(""); }} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Close</button>
                <button type="submit" style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                  {manageFieldData !== "" ? 'Update Field' : 'Add Field'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <SuccessModal message={modalData?.message} showModal={modalData?.show} setShowModal={setModalData} />
    </div>
  );
};

export default Index;
